<template>
    <transition name="silde" appear>
        <div class="type-talk" v-if="showChat" :class="chatViewClass">
            <!-- 显示状态 -->
            <div class="user-chat-container" v-show="chatViewShow">
                <!-- 头部区域 -->
                <div class="user-chat-header">
                	<img src="../../../../assets/image/minWindow.png" @click="hideChatView" alt="">
                </div>
                <!-- 内容区域 -->
                <div class="user-chat-content">
                	<div class="chat-content-view">
                		<div v-for="(item, index) in chatContent" :key="index">
                			<!-- 客服内容 -->
                			<customer-content v-if="item.type === 'customer'" :chatContent="item"></customer-content>
                			<!-- 用户内容 -->
                			<consumer-content v-if="item.type === 'consumer'" :chatContent="item"></consumer-content>
                		</div>
                	</div>
                </div>
                <!-- 底部输入发送区域 -->
                <div class="user-chat-footer">
                	<div class="chat-footer-textarea">
                		<chat-textarea v-model="chatText" @focus="toggleContact"></chat-textarea>
                	</div>
                	<div class="chat-footer-button">
                		<div class="single-button">
                			<chat-button :color="themeColor" @click="sendChatText">
                				发送
                			</chat-button>
                		</div>
                		<div class="single-button">
                			<chat-button :color="themeColor" @click="chatText = ''">
                				清空
                			</chat-button>
                		</div>
                	</div>
                </div>
                <!-- 消息提示 -->
                <chat-toast ref="message" style="bottom: 82px;position: absolute;"></chat-toast>
            </div>
            <!-- 隐藏状态 -->
            <div class="user-chat-hide-mode" v-show="!chatViewShow" @click="showChatView" :message-number="unreadMessage" :style="{ backgroundImage: 'url('+ chatPhoto +')' }" :class="unreadMessage ? 'chat-message-number' : ''"></div>
        </div>
    </transition>
</template>

<script>
	import mixin from '../mixin.js'
	import socket from 'util/socket.js'
    import { timeout } from 'util/timeout.js'
    import chatToast from './chat-toast.vue'
	import chatButton from './chat-button.vue'
	import chatTextarea from './chat-textarea.vue'
	import customerContent from './customer-content.vue'
	import consumerContent from './consumer-content.vue'
    export default {
        name: 'type-talk',
		mixins: [ mixin ],
        data() {
        	return {
                showChat: true,
        		chatText: '',			// 输入的聊天内容
        		adminUUID: '',
                chatSocket: {},
        		chatContent: [],
        		showContact: false,		// 显示联系弹窗
        		showConfirm: false,		// 关闭聊天窗口弹窗
        		chatViewShow: true,		// 聊天窗口正常(最小)化
        		chatViewClass: '',		// 切换聊天窗口模式class
        		unreadMessage: 0,		// 未读消息数量
				chatContentDiv: null
        	}
        },
        created() {
            this.getData();
        },
		mounted() {
			this.chatContentDiv = document.querySelector('.user-chat-content');
		},
        methods: {
        	getData() {
                this.$http.custom.getChatMessagesList(this.api + '/chat/getChatMessagesList', { token: this.$uuid }).then(res => {
                    if (res.code === 0 && res.data && res.data.length) {
                        for (let i = 0, length = res.data.length; i < length; i++) {
                        	let content = res.data[i].text;
                        	let time = Number(res.data[i].time);
                        	if (('admin' in res.data[i]) && (res.data[i].admin === '1')) {
                        		this.customerContentOutput(content, time);
                        	} else {
                        		this.consumerContentOutput(content, time);
                        	}
                        }
                    }
        			this.customerContentOutput('在啊客服很高兴为你服务', 0, true);
                }).catch(error => {
                    // console.error(error)
                    this.customerContentOutput('在啊客服很高兴为你服务', 0, true);
                });
        		// 链接客服聊天
                this.openChatSocket();
        	},
            openChatSocket() {
				if (this.isIframe === false) {
					this.chatSocket = socket({
						global: this,
						config: {
							debug: false,
					        connection: this.api + '?use_type=chatArtificial'
						},
						events: {
							// socket连接失败
							'error'(error) {
								console.error('socket连接失败', error);
								this.$message(error);
							},
							// socket正在连接
					        'connect'(data) {
					            console.log('连接', data)
					        	this.chatSocket.emit('communication', {
					        		deviceUUID: this.$uuid,
					        		name: this.name,
					        		account: 'user',
					        		action: '/chat/login',
					        		use_type: 'chatArtificial'
					        	});
					        },
					        // socket连接成功
					        'socketConnectioned'(data) {
					            console.log('连接成功', data)
					        	this.chatSocket.emit('communication', {
					        		deviceUUID: this.$uuid,
					        		name: this.name,
					        		account: 'user',
					        		action: '/chat/login',
					        		use_type: 'chatArtificial'
					        	});
					        },
					        // 被管理员搭理
					        '/chat/beAcceptedChat'(data) {
								console.log('被管理员搭理', data)
					        	this.adminUUID = data.msgSource;
					        },
					        // 管理员下线了
					        '/chat/beLeftChat'(data) {
								console.log('管理员下线了', data)
					        	this.adminUUID = '';
					        },
					        // 接收聊天消息
					        '/chat/serverMsg'(data) {
								console.log('接收聊天消息', data)
					        	if (data.msgSource != 'myself') {
					        		this.customerContentOutput(data.data.text);
					        		// 最小化的话
					        		if (this.chatViewShow === false) {
					        			this.unreadMessage += 1;
					        		}
					        	}
					        },
					        // 断开重连
					        'disconnect'(data) {
					            console.log('断开', data)
					            this.chatSocket.connect();
					        }
						}
					});
				}
            },
        	toggleContact() {
        		if (this.$userInfo.data.name) {
                    return;
        		}
                this.$contact().then(console.log);
        	},
        	closeUserChat() {
        		// 关闭聊天窗口
        		this.chatViewShow = true;
        		this.chatViewClass = '';
                this.showChat = false;
        	},
        	showChatView() {
        		// 聊天窗口正常化
        		this.slideBootom(800);
        		this.unreadMessage = 0;
        		this.chatViewShow = true;
        		this.chatViewClass = 'show-user-chat';
        	},
        	hideChatView() {
        		// 最小化聊天窗口
        		this.chatViewShow = false;
        		this.chatViewClass = 'hide-user-chat';
        	},
        	slideBootom(delay = 500) {
        		// 将内容滑到最底部 自动滑动到底部
                timeout(delay).then(delay => {
        			let height = this.chatContentDiv.offsetHeight;
        			let scrollTop = this.chatContentDiv.scrollHeight;
        			if (height < scrollTop) {
        				$('.user-chat-content').animate({ scrollTop: scrollTop }, 800);
        			}
        		});
        	},
        	sendChatText() {
        		if (!this.$userInfo.data.name) {
        			this.toggleContact();
        			return false;
        		}
        		if (this.chatText === '') {
        			this.$refs['message'].showToast('请输入文字后再提交');
        			return false;
        		}
        		this.consumerContentOutput(this.chatText);
        		let result = [];
        		if (this.adminUUID === '') {
        			result = this.robotReply(this.chatText);
        		}
        		if (result.length) {
        			// 机器人回答
        			this.customerContentOutput(result, 0, true);
        		} else {
        			// 发送聊天内容
					if (this.chatSocket && this.chatSocket.emit) {
						const data = {
							senderName: this.name,
							text: this.chatText,
							time: this.$time.now.timestamp
						};
						this.chatSocket.emit('communication', {
							action: '/chat/message',
							chatTarget: this.adminUUID,
							deviceUUID: this.$uuid,
							url: window.location.href,
							data: data
						});
					}
        		}
        		this.chatText = '';
        	},
        	robotReply(content = '') {
        		let result = [];
        		if (content && this.preinstallReply.length) {
        			for (let p of this.preinstallReply) {
        				if (content.includes(p.edd)) {
        					result = [...result, ...(p.su.map(v => v.ed))];
        				}
        			}
        		}
        		return result;
        	},
        	consumerContentOutput(content, time = 0) {
        		// 用户内容输入
        		time = time || this.$time.now.timestamp;
        		const data = {
        			type: 'consumer',
        			time: time,
        			photo: this.userPhoto,
        			content: content,
        			animate: true
        		};
        		this.chatContent.push(data);
        		this.slideBootom();
        	},
        	customerContentOutput(content, time = 0, robot = false) {
        		// 客服内容输入
        		time = time || this.$time.now.timestamp;
        		const data = {
        			type: 'customer',
        			time: time,
        			robot: robot,
        			photo: this.chatPhoto,
        			content: content,
        			animate: true
        		};
        		if (robot) {
					timeout(500).then(delay => {
        				this.chatContent.push(data);
        				this.slideBootom();
        			});
        		} else {
        			this.chatContent.push(data);
        			this.slideBootom();
        		}
				// console.log(
				// 	JSON.parse(JSON.stringify(data)),
				// 	JSON.parse(JSON.stringify(this.chatContent))
				// )
        	}
        },
        computed: {
            api() {
                // return 'http://192.168.0.106:23334';
                return 'http://rtservice.xitohere.com';
                return 'https://rtservice.xitohere.com';
                return process.env.NODE_ENV === 'development' ? 'http://192.168.0.106:23334' : 'http://rtservice.xitohere.com';
            },
        	name() {
        		return this.$userInfo.data.name || 'user';
        	},
        	logo() {
        		return this.showData && this.showData.logo || require('../../../../assets/image/logo.png');
        	},
			isIframe() {
				return 'iframe' in this.$route.query;
			},
        	chatPhoto() {
        		return this.showData && this.showData.logo || require('../../../../assets/image/logo.png');
        	},
        	preinstallReply() {
        		return this.showData && this.showData.data || require('../../../../../public/json/answer.json');
        	}
        },
        components: {
            'chat-toast': chatToast,
            'chat-button': chatButton,
            'chat-textarea': chatTextarea,
            'customer-content': customerContent,
            'consumer-content': consumerContent
        },
        beforeDestroy() {
            if (this.chatSocket && this.chatSocket.close) {
                this.chatSocket.close();
            }
        }
    }
</script>

<style scoped lang="less">
    .type-talk{
        // overflow: hidden;
        position: fixed;
        z-index: 111;
        .user-chat-container, .user-chat-hide-mode{
        	border-radius: 6px;
        	position: relative;
        }
        .user-chat-container{
        	overflow: hidden;
        	box-shadow: 0 0 2px #333333;
            .user-chat-header{
            	width: calc(100% - 12px);
            	height: 25px;
            	padding: 0 6px;
            	color: #000000;
            	font-size: 16px;
            	display: flex;
            	align-items: center;
            	flex-direction: row-reverse;
            	background-color: #FFFFFF;
                img{
                	width: 20px;
                	cursor: pointer;
                }
            }
            .user-chat-content{
            	width: 100%;
            	height: calc(100% - 105px);
            	transition: all 0.3s ease;
            	overflow-x: hidden;
            	overflow-y: scroll;
            	background-color: #FFFFFF;
                &::-webkit-scrollbar{
                    display: none;
                }
                .chat-content-view{
                	padding-bottom: 6px;
                }
            }
            .user-chat-footer{
            	width: 100%;
            	height: 73px;
            	padding-bottom: 6px;
            	border-top: 1px solid #CCCCCC;
            	background-color: #FFFFFF;
                div span{
                	color: #fff;
                	font-size: 16px;
                }
                .chat-footer-textarea{
                	height: 35px;
                	padding: 6px 6px 0 6px;
                	width: calc(100% - 12px);
                }
                .chat-footer-button{
                	width: 100%;
                	height: calc(100% - 41px);
                	display: flex;
                	align-items: flex-end;
                	flex-direction: row-reverse;
                    .single-button{
                    	width: 60px;
                    	height: 26px;
                    	margin-right: 6px;
                    	display: inline-block;
                    }
                }
            }
        }
        .user-chat-hide-mode{
        	cursor: pointer;
        	background-image: url(../../../../assets/image/logo.png);
        	background-position: center center;
        	background-repeat: no-repeat;
        	background-size: cover;
        }
        .chat-message-number::after{
        	content: attr(message-number);
        	position: absolute;
        	top: -25%;
        	right: -25%;
        	width: 25px;
        	height: 25px;
        	color: #FFFFFF;
        	font-size: 12px;
        	transform: scale(0.8);
        	border-radius: 50%;
        	background-color: #F56C6C;
        	display: flex;
        	align-items: center;
        	justify-content: center;
        }
        .chat-message-number:hover::after{
        	box-shadow: 0 3px 10px #333333;
        }
    }
    .silde-enter-active{
    	animation: silde 300ms ease-in 700ms forwards reverse;
    }
    .silde-leave-active{
    	animation: silde 300ms ease-in 700ms forwards reverse;
    }
    .show-user-chat{
    	animation: show-user-chat 300ms ease-in forwards;
    }
    .hide-user-chat{
    	animation: hide-user-chat 300ms ease-in forwards;
    }
    @media screen and (max-width: 719px){
    	.type-talk{
    		width: 90vw;
    		height: 300px;
    		top: 10px;
    		right: 5vw;
            .user-chat-container, .user-chat-hide-mode{
            	width: 100%;
            	height: 100%;
            }
    	}
    	@keyframes silde{
    		0%{
                top: -310px;
    		}
    		100%{
                top: 10px;
    		}
    	}
    	@keyframes show-user-chat{
    		from{
    			width: 40px;
    			height: 40px;
    		}
    		to{
    			width: 90vw;
    			height: 300px;
    		}
    	}
    	@keyframes hide-user-chat{
    		from{
    			width: 90vw;
    			height: 300px;
    		}
    		to{
    			width: 40px;
    			height: 40px;
    		}
    	}
    }
    @media screen and (min-width: 720px){
    	.type-talk{
    		width: 400px;
    		height: 480px;
    		bottom: 90px;
    		right: 30px;
            .user-chat-container, .user-chat-hide-mode{
            	width: 100%;
            	height: 100%;
            }
    	}
    	@keyframes silde{
    		0%{
    			right: -410px;
    		}
    		100%{
    			right: 20px;
    		}
    	}
    	@keyframes show-user-chat{
    		from{
    			width: 40px;
    			height: 40px;
    		}
    		to{
    			width: 400px;
    			height: 480px;
    		}
    	}
    	@keyframes hide-user-chat{
    		from{
    			width: 400px;
    			height: 480px;
    		}
    		to{
    			width: 40px;
    			height: 40px;
    		}
    	}
    }
</style>
